<template>
  <div>
    <v-dialog
      v-model="showDialog"
      width="400"
    >
      <v-card>
        <v-card-text
          style="max-height: 70vh;overflow:auto;"
        >
          <div
            v-for="(list,addrid) in addrQaMap"
            :key="addrid"
          >
            <v-layout
              align-center
              justify-center
              class="py-4"
            >
              <template v-if="addrid === '1024'">
                <div
                  class="whsIcon"
                  style="background: #665be8"
                >
                  <svg
                    class="svg-icon"
                    aria-hidden="true"
                    style="font-size:  20px;"
                  >
                    <use xlink:href="#iconshenzhen" />
                  </svg>
                </div>
                <div class="mx-2 title blue--text">
                  深圳倉熱點問題
                </div>
              </template>
              <template v-else-if="addrid === '1210'">
                <div
                  class="whsIcon"
                  style="background: #d85747"
                >
                  <svg
                    class="svg-icon"
                    aria-hidden="true"
                    style="font-size:  20px;"
                  >
                    <use xlink:href="#iconshanghai" />
                  </svg>
                </div>
                <div class="mx-2 title blue--text">
                  上海倉熱點問題
                </div>
              </template>
              <template v-else-if="addrid === '1591'">
                <div
                  class="whsIcon"
                  style="background: #279d00"
                >
                  <svg
                    class="svg-icon"
                    aria-hidden="true"
                    style="font-size:  20px;"
                  >
                    <use xlink:href="#iconfuzhou_hei" />
                  </svg>
                </div>
                <div class="mx-2 title blue--text">
                  福州倉熱點問題
                </div>
              </template>
              <template v-else>
                <div class="mx-2 title blue--text">
                  熱點問題
                </div>
              </template>
            </v-layout>
            <div>
              <div
                v-for="(que,i) in list"
                :key="que.queid"
              >
                <v-layout
                  align-start
                  class="ma-0"
                >
                  <div>
                    {{ i+1 }}.
                  </div>
                  <v-flex>
                    <div class="mb-2">
                      <HtmlViwer :content="que.queCont" />
                    </div>
                    <v-layout class="ma-0 mb-2">
                      <v-layout
                        v-for="(choiceItem) in que.choice"
                        :key="choiceItem.choid"
                        align-start
                        class="ma-0"
                        style="flex:1;cursor:pointer;"
                        @click="answerMap[que.queid] = choiceItem.choid"
                      >
                        <v-icon
                          v-if="answerMap[que.queid] === choiceItem.choid"
                          class="blue--text"
                        >
                          radio_button_checked
                        </v-icon>
                        <v-icon
                          v-else
                        >
                          radio_button_unchecked
                        </v-icon>
                        <div class="ml-2">
                          <HtmlViwer :content="choiceItem.choCont" />
                        </div>
                        <div v-if="answerMap[que.queid]">
                          <v-icon
                            v-if="choiceItem.choRight === '1'"
                            class="success--text"
                          >
                            check
                          </v-icon>
                          <v-icon
                            v-else-if="answerMap[que.queid] === choiceItem.choid"
                            class="error--text"
                          >
                            close
                          </v-icon>
                        </div>
                      </v-layout>
                    <!-- <v-layout>
                      <v-icon class="blue--text">radio_button_checked</v-icon>
                      <div class="ml-2">n
                        可以
                      </div>
                      <div>
                        <v-icon
                          class="error--text">close</v-icon>
                      </div>
                    </v-layout> -->
                    </v-layout>
                  </v-flex>
                </v-layout>

                <div v-if="answerMap[que.queid] && que.queDesc">
                  <HtmlViwer :content="que.queDesc" />
                </div>

                <v-divider class="my-2" />
              </div>
            </div>
          </div>
          <div class="mt-4 pb-2">
            <v-btn
              :disabled="chosedLen<list.length"
              block
              color="info"
              @click="submit"
            >
              關閉
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    isCreate: Boolean,
  },
  data () {
    return {
      showDialog: false,
      list: [],
      answerMap: {
        // [queid]: choid
      },
      addrQaMap: {},
    }
  },
  computed: {
    chosedLen () {
      return Object.values(this.answerMap).filter(item => item).length
    },
  },
  mounted () {
  },
  methods: {
    open () {
      if (!this.isCreate) return
      if (!sessionStorage.hotqasubmited) {
        this.fetchQa()
      }
    },
    async fetchQa () {
      const res = await this.$store.dispatch('quiz/question/hot')
      const addrids = this.$store.state.parcel.hasParcelsAddrids
      const list = res.data.list.filter(item => !item.queWhsAddrid || item.queWhsAddrid === '0' || addrids.includes(item.queWhsAddrid))

      const addrQaMap = {}

      const answerMap = {}
      list.forEach(item => {
        answerMap[item.queid] = ''
        if (!addrQaMap[item.queWhsAddrid]) {
          addrQaMap[item.queWhsAddrid] = []
        }
        addrQaMap[item.queWhsAddrid || '0'].push(item)
      })
      this.answerMap = answerMap
      this.addrQaMap = addrQaMap
      this.list = list
      if (list.length) {
        this.showDialog = true
      }
    },
    submit () {
      sessionStorage.hotqasubmited = '1'
      this.showDialog = false
    },
  },
}
</script>
<style lang="postcss" scoped>
.whsIcon {
  border-radius: 50%;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
  background: #fff;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
